<template>
	<div class="p-6 space-y-6">
		<!-- m-6  shadow bg-white rounded-xl -->
		<h1 class="text-3xl font-semibold text-gray-900 mb-4">
			{{ __("Administration") }}
		</h1>

		<div class="grid grid-cols-8 gap-y-4 gap-x-6">
			<ui-input-group
				class="col-span-2"
				v-model="user.id"
				label="ID"
				:disabled="true"
				:form="form"
				field="id"
				:required="true"
			/>
			<ui-select-group
				class="col-span-3"
				v-model="form.status"
				field="status"
				label="Status"
				:form="form"
				:required="true"
				:options="$cropOptions.userStatusOptions"
			/>

			<ui-select-group
				class="col-span-3"
				v-model="form.role"
				field="role"
				label="Role"
				:form="form"
				:required="false"
				:options="$cropOptions.userRoleOptions"
			/>

			<ui-input-group
				class="col-span-8"
				v-model="user.email"
				label="E-Mail"
				:form="form"
				field="email"
				:required="true"
			/>
		</div>

		<div>
			<h2 class="text-xl font-semibold text-gray-900 mb-4">
				{{ __("Activation") }}
			</h2>

			<div class="pt-2 flex gap-x-2">
				<ui-icon
					:class="[
						'w-5 h-5',
						user.email_verified_at == null ? 'text-red-400' : 'text-green-400',
					]"
					:stroke-width="2"
					:name="user.email_verified_at == null ? 'x-circle' : 'check-circle'"
				/>
				<span v-if="user.email_verified_at == null"
					>{{ __("E-Mail not confirmed") }}
					<ui-button
						v-on:click="
							$inertia.post(
								$route('admin.users_resendVerify', {
									id: user.id,
								}),
								{ replace: false }
							)
						"
						label="Resend Verification Email"
					/>
				</span>
				<span v-else>{{ __("E-Mail successfully confirmed") }}</span>
			</div>

			<div class="pt-2 flex gap-x-2">
				<ui-icon
					:class="[
						'w-5 h-5',
						user.address.zip == null ? 'text-red-400' : 'text-green-400',
					]"
					:stroke-width="2"
					:name="user.address.zip == null ? 'x-circle' : 'check-circle'"
				/>
				<span v-if="user.address.zip == null">{{
					__("Profile not completed")
				}}</span>
				<span v-else>{{ __("Profile completed") }}</span>
			</div>
		</div>

		<hr />

		<div>
			<h2
				class="mb-4 text-xl font-semibold text-gray-900 mb-4"
				v-if="adminUser.role == 'ADMIN'"
			>
				Tagespreise
			</h2>
			Alle Landwirte in DE können automatisch den Preisticker sehen!
			<div
				class="grid grid-cols-8 gap-y-4 gap-x-6 items-end pb-4 pt-4"
				v-if="adminUser.role == 'ADMIN'"
			>
				<span
					class="flex gap-x-2"
					v-if="(user.type == 'FARMER') & (user.address.country == 'DE')"
				>
					<ui-icon
						class="w-5 h-5 text-green-400"
						:stroke-width="2"
						name="check-circle"
					/>
					<span>Kann Preisticker sehen</span>
				</span>
				<ui-check-group
					v-else
					class="col-span-4"
					:form="form"
					field="acl.price_indication"
					v-model="form.acl.price_indication"
					label="Kann Preisticker sehen"
				/>

				<ui-check-group
					class="col-span-4"
					:form="form"
					field="acl.price_indication_edit"
					v-model="form.acl.price_indication_edit"
					label="Kann Flächengebot aktivieren"
				/>
			</div>

			<hr class="pt-4 pb-4" />

			<h2 class="text-xl font-semibold text-gray-900 mb-4">
				{{ __("Advanced Features") }}
			</h2>
			<div
				class="grid grid-cols-8 gap-y-4 gap-x-6 items-end"
				v-if="adminUser.role == 'ADMIN'"
			>
				<ui-check-group
					class="col-span-4 pb-2 mb-px"
					:form="form"
					field="can_manage"
					v-model="form.can_manage"
					label="Can manage other users (Mandanten-Boss)"
				/>

				<ui-input-group
					class="col-span-4"
					v-model="user.managed_by"
					label="Managed by (ID)"
					:form="form"
					field="managed_by"
					:required="false"
				/>

				<div class="col-span-3" v-if="boss">
					<span>Managed by {{ boss.company_name }}</span>
				</div>

				<ui-check-group
					class="col-span-4"
					:form="form"
					field="can_paper"
					v-model="form.can_paper"
					label="Paper Market"
				/>

				<ui-check-group
					class="col-span-8"
					:form="form"
					field="can_auction"
					v-model="form.can_auction"
					label="Kann Auktionsraum sehen"
				/>

				<ui-check-group
					class="col-span-8"
					:form="form"
					field="acl.auction_edit"
					v-model="form.acl.auction_edit"
					label="Kann Angebote im Auktionsraum einstellen"
				/>
			</div>

			<div class="pt-6 flex gap-x-4">
				<ui-button
					v-on:click="$inertia.visit(sudoBecomeUrl)"
					label=""
					class="flex items-center"
				>
					<ui-icon name="ghost" stroke-width="2" class="-ml-1 w-5 h-5 mr-2" />
					{{ __("Login as this user") }}
				</ui-button>
				<ui-button
					type="secondary"
					v-on:click="$inertia.visit(logUrl)"
					class="flex items-center"
				>
					<ui-icon
						name="bar-chart-2"
						stroke-width="2"
						class="-ml-1 w-5 h-5 mr-2"
					/>
					{{ __("Show activity") }}
				</ui-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		boss: {
			type: Object,
			required: false,
		},
		form: {
			type: Object,
			required: true,
		},
		canAdvanced: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			adminUser: this.$inertia.page.props.user,
		};
	},
	computed: {
		sudoBecomeUrl() {
			return window.baseUrl + "/sudo/become/" + this.user.id;
		},
		logUrl() {
			return window.baseUrl + "/admin/logs/" + this.user.id;
		},
	},
};
</script>
